import { useState } from "react";
import { Plus, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import TagButton from "@/components/TagButton";

export const CustomTagButton = ({ label, selected, onToggle, onRemove, testId }) => (
  <div className="relative group/custom" data-testid={`${testId}-wrapper`}>
    <TagButton label={label} selected={selected} onToggle={onToggle} testId={testId} custom />
    <button
      type="button"
      onClick={onRemove}
      aria-label="Ukloni vlastitu oznaku"
      data-testid={`${testId}-remove`}
      className="absolute -top-2 -right-2 h-6 w-6 grid place-items-center rounded-full bg-white border border-slate-200 text-slate-400 shadow-sm opacity-0 group-hover/custom:opacity-100 focus:opacity-100 hover:text-red-600 hover:border-red-200 transition-opacity"
    >
      <X className="h-3.5 w-3.5" />
    </button>
  </div>
);

export const CustomTagAdder = ({ onAdd }) => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (onAdd(text)) {
      setText("");
      setOpen(false);
    }
  };

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="add-custom-tag-btn"
        className="flex items-center justify-center gap-1.5 rounded-xl min-h-[3.75rem] px-3 border border-dashed border-slate-300 text-sm font-medium text-slate-500 hover:text-blue-700 hover:border-blue-400 hover:bg-blue-50/50 transition-colors"
      >
        <Plus className="h-4 w-4" />
        Dodaj vlastitu oznaku
      </button>
    );
  }

  return (
    <form
      onSubmit={submit}
      className="col-span-2 md:col-span-3 lg:col-span-2 flex items-center gap-2 rounded-xl border border-blue-300 bg-white p-2"
      data-testid="custom-tag-form"
    >
      <Input
        autoFocus
        value={text}
        maxLength={90}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => e.key === "Escape" && setOpen(false)}
        placeholder="npr. Rado pomaže u pripremi pokusa"
        data-testid="custom-tag-input"
        className="border-0 shadow-none focus-visible:ring-0 h-9"
      />
      <Button type="submit" size="sm" className="bg-blue-600 hover:bg-blue-700 text-white" data-testid="custom-tag-save-btn">
        Dodaj
      </Button>
      <Button type="button" size="sm" variant="ghost" onClick={() => setOpen(false)} data-testid="custom-tag-cancel-btn">
        <X className="h-4 w-4" />
      </Button>
    </form>
  );
};
